import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc Fetch application-wide context information including global URLs and labels.
 * @example
 * import { HttpService } from 'core/modules/network-service';
 *
 * // create service instance and send/cancel request
 * const getAppContextService = new GetAppContextService();
 * const result = await getAppContextService.fetchData( '<user-id>' ); // fetch data
 * getAppContextService.cancel(); // cancel an active request
 */
export class GetAppContextService extends HttpService {

    // make request and fetch data
    async postData( { data = {} } = {} ) {
        return await this.post( {
            host: CONFIG.host,
            path: get( CONFIG, 'endpoints.authentication.fetchAppContext', '' ),
            data,
        } );
    }

    // submit ePost ID
    async submitEpostId( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data,
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data.state', get( response, 'body.component.data', {} ) ),
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
